import type { ReactNode } from "react";

import { Spinner } from "@alpacahq/ui/old";

import { FAQ } from "~/v2/components/common/FAQ";
import { BlueLinesBackground } from "./BlueLinesBackground";
import { HIGH_YIELD_CASH_FAQ_ITEMS } from "./HighYieldCashFAQ";

export interface LayoutProps {
  title: string;
  showFAQ?: boolean;
  isLoading?: boolean;
  children: ReactNode;
}

export const Layout = ({
  title,
  showFAQ = false,
  isLoading,
  children,
}: LayoutProps) => {
  return (
    <div className="flex h-full w-full justify-center">
      <BlueLinesBackground />

      <section className="relative z-10 h-full w-full px-4 pt-16 pb-56 md:pt-32">
        <div className="mx-auto flex max-w-4xl flex-col gap-8">
          <h1 className="m-0 font-medium text-4xl">{title}</h1>
          {isLoading ? <Spinner className="mx-auto mt-16" /> : children}
          {showFAQ && (
            <div>
              <FAQ
                hideContactUs
                faq={HIGH_YIELD_CASH_FAQ_ITEMS}
                titleClassName="text-2xl font-medium mb-4"
                itemClassName="bg-white border border-cool-gray-200 mb-2"
              />
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
